import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
// สมมติว่าคุณมี Footer ถ้าไม่มีให้เอาออกได้ครับ
// import Footer from '../components/Footer'; 

const CanvaGamePage = () => {
    return (
        <div className="min-h-screen flex flex-col text-[#111518] bg-[#fff7f0]">
            <Helmet>
                <title>Lanna Games</title>
            </Helmet>

            <SiteHeader />

            <main className="flex-grow py-8 px-4">
                <div className="max-w-4xl mx-auto">
                    {/* ปุ่มย้อนกลับ */}
                    <Link 
                        to="/games" // เปลี่ยนให้ตรงกับ path หน้ารวมเกมของคุณ
                        className="inline-block mb-6 px-4 py-2 bg-amber-100 text-amber-800 rounded-lg hover:bg-amber-200 transition-colors font-medium"
                    >
                        ← กลับไปหน้ารวมเกม
                    </Link>

                    <div className="bg-white p-4 md:p-8 rounded-3xl shadow-xl border border-stone-100">
                        <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 text-gray-800">
                            เกมตอบคำถามเกี่ยวกับอาหารล้านนา
                        </h1>

                        {/* โค้ด Canva ที่แปลงเป็น JSX แล้ว */}
                        <div style={{ 
                            position: 'relative', 
                            width: '100%', 
                            height: 0, 
                            paddingTop: '56.2500%', 
                            paddingBottom: 0, 
                            boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)', 
                            marginTop: '1.6em', 
                            marginBottom: '0.9em', 
                            overflow: 'hidden', 
                            borderRadius: '8px', 
                            willChange: 'transform' 
                        }}>
                            <iframe 
                                loading="lazy" 
                                style={{ 
                                    position: 'absolute', 
                                    width: '100%', 
                                    height: '100%', 
                                    top: 0, 
                                    left: 0, 
                                    border: 'none', 
                                    padding: 0, 
                                    margin: 0 
                                }}
                                src="https://www.canva.com/design/DAHIIO14Opg/w3x0KDHEJZ9JG_HEjocsYQ/view?embed" 
                                allowFullScreen="allowfullscreen" 
                                allow="fullscreen">
                            </iframe>
                        </div>

                        <div className="text-center mt-4 text-sm text-gray-500">
                            <a 
                                href="https://www.canva.com/design/DAHIIO14Opg/w3x0KDHEJZ9JG_HEjocsYQ/view?utm_content=DAHIIO14Opg&utm_campaign=designshare&utm_medium=embeds&utm_source=link" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-amber-600 hover:underline"
                            >
                                เปิดดูใน Canva เต็มจอ
                            </a>
                        </div>
                    </div>
                </div>
            </main>

            {/* <Footer /> */}
        </div>
    );
};

export default CanvaGamePage;